import React from 'react'
import {TextArea,Checkbox, Form, Button, Message, Modal, Select, Image, Confirm} from 'semantic-ui-react'
import PickList from '../PickList'

const {Field} = Form
const modalStyle = { marginTop: '5%', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class EditForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {openConfirm: false}
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    this.props.onRemove(this.props.editForm.id)
    this.setState({openConfirm: false})
    this.props.cancelEdit()
  }
  render () {
    const fieldTypes = [
      {key: 1, value: 'Text', text: 'Text'},
      {key: 2, value: 'Picklist', text: 'Single select'},
      {key: 3, value: 'Single select (API)', text: 'Single select (API)'},
      {key: 4, value: 'TeamMember', text: 'Team member'},
      {key: 5, value: 'Calendar', text: 'Calendar'}
    ]
    const editForm = (
      <div>
        <Form id='editForm' loading={this.props.editForm.isLoading} onSubmit={this.props.onEditFormSubmit}>
          {this.props.editForm.postSuccess ? (<Message positive>
            <Message.Header>Successfully update new custom field</Message.Header>
          </Message>) : undefined}

          {this.props.editForm.error ? (<Message negative>
            <Message.Header>{this.props.editForm.errorMessage}</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='field_name'>Title</label>
            <TextArea rows={1} autoHeight id='name' name='name' value={this.props.editForm.name}
              onChange={this.props.onEditFormFieldChange} required />
          </Field>
          <Field>
            <label htmlFor='field_title' >Placeholder</label>
            <TextArea rows={1} autoHeight id='title' name='title' value={this.props.editForm.title}
              onChange={this.props.onEditFormFieldChange} disabled={this.props.editForm.value_type === 'Picklist'} required={this.props.editForm.value_type !== 'Picklist'} />
          </Field>
          <Field>
            <label htmlFor='field_value_type'>Value type</label>
            <Select id='field_value_type' name='field_value_type' value={this.props.editForm.value_type} options={fieldTypes} onChange={this.props.onEditFormSelectChange} />
          </Field>
          {this.props.editForm.value_type === 'Picklist' ? (
            <PickList
              handlePickListAddClick={this.props.handlePickListAddClick}
              onPickListFieldChange={this.props.onPickListFieldChange}
              pickListItems={this.props.pickListItems}
              newSelectionValue={this.props.newSelectionValue}
              onPickListItemDelete={this.props.onPickListItemDelete}
            />
          ) : undefined }
          {this.props.editForm.value_type === 'Single select (API)' ? (
            <div style={{marginBottom: '20px'}}>
              <p><strong>Please follow below Curl command as an example to add values to this field</strong></p>
              <p>{`curl -X POST ${process.env.REACT_APP_BACKEND_API}/webhook/customfields/api-values -H 'Content-Type: application/json' -d '{"authenticator": "${this.props.editForm.authenticator}", "list_values": ["alpha", "beta"]}'`}</p>
            </div>
            ) : undefined}
          <Field>
            <Checkbox label='Make this field required' checked={this.props.editForm.required} onChange={this.props.onEditFormMandatoryChange} />
          </Field>
        </Form>
      </div>
    )
    const modal = (
      <Modal open={this.props.showEditForm} style={modalStyle} onClose={this.props.cancelEdit}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit custom field
          <a href='#'>
            <Image onClick={this.props.cancelEdit} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
          <a href='#'>
            <Image onClick={this.showConfirm.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px', marginRight: '20px'}} avatar src={'/icons/delete_1397562.svg'} />
          </a>
          <Confirm
            style={confirmStyle}
            open={this.state.openConfirm}
            onCancel={this.handleCancel.bind(this)}
            onConfirm={this.handleConfirm.bind(this)}
            content='Are you sure you want to delete this custom field?'
            confirmButton='Yes'
          />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

export default EditForm



// WEBPACK FOOTER //
// ./src/pages/settings/template-customisation/components/edit/index.js